<template>
  <sl-page>
    <div class="page-filter">
      <sl-search @search="search" @reset="reset">
        <sl-search-item label="">
          <Input v-model="params.carNo" placeholder="车辆编号" />
        </sl-search-item>
        <sl-search-item label="">
          <Input v-model="params.licenseNo" placeholder="车牌号" />
        </sl-search-item>
        <sl-search-item label="">
          <Input v-model="params.companyName" placeholder="企业名称" />
        </sl-search-item>
      </sl-search>
    </div>
    <div class="flex" style="margin-bottom:16px;">
      <time-range size="small" v-model="params.rangeTime" :shortcuts="['today','yesterday','week','lastweek','month','lastmonth']" @change="handleChangeTime" default-value="today" />
    </div>
    <div class="pg-bd">
      <sl-table ref="table" :loading="loading" :page="page" :columns="columns" :data="data" @on-selection-change="handleSelect" @on-update="handleChange"></sl-table>
    </div>
  </sl-page>
</template>
<script>
import { createDict } from '@/util/dicts'
import { mileageDisplay , km } from './utils'
import global from '@/util/mixin/global'
import moment from '@/util/format/moment'
import TimeRange from './partial/time-range'

export default {
  mixins:[global],
  components:{TimeRange},
  data() {
    let cols = []

    return {
      columns: [
        {
          title: '车辆',
          minWidth: 200,
          maxWidth: 450,
          render: (h, { row }) => {
            return h('div', [
              h('div',{class:'tb-list-item-cell'},[ h('div',{class:'tb-list-item-cell-l'} , 'No.'+row.carNo),h('div',{class:'tb-list-item-cell-r'} , [h('span',{class:'tag-car-license0'},row.licenseNo)])]),
              h('div',{class:'tb-list-item-cell'},[ h('div',{class:'tb-list-item-cell-l light'} , row.companyName),h('div',{class:'tb-list-item-cell-r'} , row.courierName)]),
            ])
          }
        },
        {
          title: '总里程数',
          key: 'totalMileageText',
          minWidth: 120,
        },
        {
          title: '查询里程数',
          key: 'mileageText',
          minWidth: 120,
        },
        {
          title: '总时长',
          key: 'totalDurationText',
          minWidth: 100,
        },
        {
          title: '查询时长',
          key: 'durationText',
          minWidth: 100,
        },
        
      ],
      data: [],
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      modalVisible: false,
      selection: [],
      params: {
        companyName: null,
        carNo:null,
        licenseNo:null,
        rangeTime: null,
      },
    }
  },

  computed: {
    removeDisable() {
      return this.selection.length == 0
    },
    searchLabel() {
      return this.visibleSearchBox ? '收起' : '高级搜索'
    },
    importUrl() {
      return this.$request.courierImportUrl()
    }
  },
  watch: {
    $route(to, from) {
      this.search()
    }
  },
  created() {
    this.def = { ...this.params }
    this.search()
  },

  methods: {

    search() {
      let { rangeTime , ...search } = this.params
      if( rangeTime && rangeTime.length == 2 ){
        search.startDate = moment(rangeTime[0])
        search.endDate = moment(rangeTime[1])
      }

      this.loading = true
      this.$request.statsCar({ search, pageSize: this.page.pageSize, pageNum: this.page.pageNum,}).then(resp => {
        this.loading = false
        if (!resp.code) {
          this.data = this.$utils.flat(this.$utils.conv(resp.data.list || [], { duration:'duration' ,totalDuration:'duration' , mileage:'distance' , totalMileage:'distance'}))
          this.page.total = resp.data.total || 0
        }
      })
    },

  
    reset() {
      this.params = {}
      this.search()
    },

    handleChange(pageNum, pageSize) {
      if (this.page.pageNum != pageNum || this.page.pageSize != pageSize) {
        this.page.pageNum = pageNum
        this.page.pageSize = pageSize
        this.search()
      }
    },

    handleSelect(selection) {
      this.selection = selection.map(i => i.id)
    },
    handleChangeTime(v) {
      this.search()
    },
  }
}

</script>
